import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { OrganizationService } from 'src/app/private/services/organization.services';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-create-organization-config',
  imports: [SharedModule, ToggleSwitchModule],
  templateUrl: './create-organization-config.component.html',
  styleUrl: './create-organization-config.component.scss'
})
export class CreateOrganizationConfigComponent {
  @Input() type: string = 'Create';
  @Input() orgId: string = '';
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();
  @Input() orgDataToEdit: any = null;

  configForm!: FormGroup;
  submitted = false;
  isLoading = false;

  gateways = [
    { label: 'PayPal', value: 'PayPal' },
    { label: 'Stripe', value: 'Stripe' },
    { label: 'Razorpay', value: 'Razorpay' }
  ];

  constructor(private fb: FormBuilder,
    private orgService: OrganizationService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.configForm = this.fb.group({
      organization_id: [this.orgId],
      email_config: this.fb.group({
        clientName: [''],
        clientComplement: [''],
        speciality_title: [''],
        support_email_id: ['', [Validators.email]],
        ses: this.fb.group({
          host: [''],
          port: [''],
          user: [''],
          api_key: [''],
          password: [''],
          from_email: [''],
          reply_to_email: ['']
        }),
        gmail: this.fb.group({
          host: [''],
          port: [''],
          password: this.fb.group({
            iv: [''],
            content: ['']
          }),
          from_email: ['']
        }),
        yahoo: this.fb.group({
          host: [''],
          port: [''],
          password: this.fb.group({
            iv: [''],
            content: ['']
          }),
          from_email: ['']
        })
      }),
      whats_app_config: this.fb.group({
        email: [''],
        app_id: [''],
        source: [''],
        api_key: [''],
        app_name: [''],
        password: [''],
        app_token: ['']
      }),
      payment_config: this.fb.group({
        gateway: ['PayPal'],
        api_key: ['']
      }),
      is_notification_enabled: [false],
      charges: this.fb.group({
        subscription_fee: [0],
        transaction_fee: [0]
      }),
      payment_method: ['']
    });


    if (this.type === 'Update' && this.orgDataToEdit) {
      this.configForm.patchValue({
        organization_id: this.orgDataToEdit.organization_id,
        email_config: this.orgDataToEdit.email_config,
        whats_app_config: this.orgDataToEdit.whats_app_config,
        payment_config: this.orgDataToEdit.payment_config,
        is_notification_enabled: this.orgDataToEdit.is_notification_enabled,
        charges: this.orgDataToEdit.charges,
        payment_method: this.orgDataToEdit.payment_method
      });
    }

  }

  handleCloseDialog() {
    this.close.emit();
  }

  submitForm(): void {
    this.submitted = true;

    if (this.configForm.invalid) {
      return;
    }

    this.isLoading = true;

    if (this.type === 'Create') {
      this.orgService.createOrgConfig(this.configForm.value).subscribe({
        next: (res) => {
          this.isLoading = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Organization Config Created Successfully'
          });
          this.handleCloseDialog();
          this.reload.emit();
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to create Organization Config'
          });
          this.isLoading = false;
        }
      }
      );
    } else {
      const payload = {
        id: this.orgDataToEdit.id,
        ...this.configForm.value
      }
      console.log("payload", payload);
      console.log("orgDataToEdit", this.orgDataToEdit);
      this.orgService.updateOrgConfig(payload).subscribe({
        next: (res) => {
          this.isLoading = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Organization Config Updated Successfully'
          });
          this.handleCloseDialog();
          this.reload.emit();
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update Organization Config'
          });
          this.isLoading = false;
        }
      });
    }
  }
}
